import { Box, Paper } from "@mui/material";

import { paramsBuyerListingValues, ROUTES } from "../../../utils/constants";

interface MetricsCardCountProps {
  count: number;
  homeSiteIds: string[];
}
interface MetricsCardProps {
  metrics: {
    newSalesLast7Days: MetricsCardCountProps;
    closingsIn14Days: MetricsCardCountProps;
    weeklyUpdate: MetricsCardCountProps;
    closingsThisMonth: MetricsCardCountProps;
    closingsIn60days?: MetricsCardCountProps;
    closingsIn30days?: MetricsCardCountProps;
    ecoeMismatch?: MetricsCardCountProps;
  };
  navigate: (path: string) => void;
}

const MetricsCardComponent: React.FC<MetricsCardProps> = ({
  metrics,
  navigate,
}) => (
  <Box sx={{ left: 1, gap: 2, display: "flex" }}>
    {[
      {
        label: "New sales in previous 7 days",
        value: metrics.newSalesLast7Days.count,
        filterValue: paramsBuyerListingValues.newSalesLast7Days,
      },
      {
        label: "Closings in next 14 days",
        value: metrics.closingsIn14Days.count,
        filterValue: paramsBuyerListingValues.closingsIn14Days,
      },
      {
        label: "ECOE Mismatches",
        value: metrics.ecoeMismatch?.count,
        filterValue: paramsBuyerListingValues.ecoeMismatch,
      },
      {
        label: "Buyers needing a weekly update",
        value: metrics.weeklyUpdate.count,
        filterValue: paramsBuyerListingValues.weeklyUpdate,
      },
    ].map((item, index) => (
      <Box key={index} sx={{ width: "589px", gap: "24px", left: 1 }}>
        <Paper
          style={{
            height: "70px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "8px",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate(
              `${ROUTES.closings.buyerListing.route}?timePeriod=${item.filterValue}`
            )
          }
        >
          <div
            style={{ fontSize: "16px", fontWeight: "400", color: "#0E171F" }}
          >
            {item.label}
          </div>
          <span
            style={{ fontSize: "32px", fontWeight: "400", color: "#0E171F" }}
          >
            {item.value}
          </span>
        </Paper>
      </Box>
    ))}
  </Box>
);

export default MetricsCardComponent;
